var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0C16.299 0 21 4.70101 21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM17.165 14.5704V6.76668L13.2629 10.6685L17.165 14.5704ZM4.66856 14.7294H16.3317L12.7671 11.1648L11.4085 12.5232C11.3427 12.5889 11.2534 12.6258 11.1604 12.6257H9.83969C9.79361 12.6258 9.74798 12.6167 9.7054 12.5991C9.66281 12.5815 9.62411 12.5557 9.5915 12.5232L8.23298 11.1648L4.6684 14.7294H4.66856ZM3.83496 6.76643V14.5706L7.73706 10.6685L3.83496 6.76643ZM16.669 6.27059H4.33125L9.98501 11.9243H11.0152L16.669 6.27059Z",
    fill: "#F1EEF9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.19a16273208e601d7007945d96c68c53.svg";
export { ForwardRef as ReactComponent };